import { render, staticRenderFns } from "./citiesAddNewData.vue?vue&type=template&id=dd716456&scoped=true"
import script from "./citiesAddNewData.vue?vue&type=script&lang=js"
export * from "./citiesAddNewData.vue?vue&type=script&lang=js"
import style0 from "./citiesAddNewData.vue?vue&type=style&index=0&id=dd716456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd716456",
  null
  
)

export default component.exports